import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { employeeService } from "../../employee/employeeService";

const getEmployeeLabel = (employee) => {
  if (!employee) return "";
  const name = employee.name || "Unnamed";
  const code = employee.employeeId || employee.email || employee._id;
  return `${name} (${code})`;
};

const usePerformanceUsers = () => {
  const usersQuery = useQuery({
    queryKey: ["performance.users"],
    queryFn: employeeService.getAllEmployees,
  });

  const users = useMemo(() => {
    const rows = Array.isArray(usersQuery.data) ? usersQuery.data : [];
    return [...rows].sort((a, b) =>
      getEmployeeLabel(a).localeCompare(getEmployeeLabel(b)),
    );
  }, [usersQuery.data]);

  const userOptions = useMemo(
    () =>
      users.map((user) => ({
        value: user._id,
        label: getEmployeeLabel(user),
      })),
    [users],
  );

  return {
    users,
    userOptions,
    isLoading: usersQuery.isLoading,
    isError: usersQuery.isError,
  };
};

export default usePerformanceUsers;
